import "@shoelace-style/shoelace/dist/components/dialog/dialog.js";
import "@shoelace-style/shoelace/dist/components/button/button.js";

import { css, html } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";
import { parseGeoCoordinates } from "../ParseGeoCoordinate";
import { makeCustomEvent } from "../Utils";
import { ILocation } from "../models/ILocation";
import SlDialog from "@shoelace-style/shoelace/dist/components/dialog/dialog";
import { litIf } from "./LitUtils";

@customElement("ds-text-to-decimal-degrees")
export class TextToDecimalDegrees extends BaseElement {
    static override styles = [Style, css``];
    @property({ type: String }) propName: any;

    private _update(text: string) {
        const location = parseGeoCoordinates(text);
        if (location) {
            this.dispatchEvent(
                makeCustomEvent("ds-changed", {
                    location,
                })
            );
        } else {
            this.dispatchEvent(
                makeCustomEvent("ds-error", {
                    text,
                })
            );
        }
    }

    override render() {
        return html`
            <p>
                This allows for many different degree / minute / second formats as well as decimal
                degrees.
            </p>
            <sl-input
                clearable
                type="text"
                @sl-input=${(e: any) => this._update(e.target.value)}
            ></sl-input>
        `;
    }
}

@customElement("ds-text-to-decimal-degrees-dialog")
export class TextToDecimalDegreesDialog extends BaseElement {
    static override styles = [Style, css``];

    @property({ type: Boolean }) open = false;

    @state() protected _location: ILocation | undefined;

    @query("#dialog") _dialog: SlDialog | undefined;

    public show() {
        this._dialog?.show();
    }

    private hide() {
        this._dialog?.hide();
    }

    protected override firstUpdated(): void {
        if (this.open) {
            this.show();
        }
    }
    protected cancel() {
        this.dispatchEvent(
            new CustomEvent("on-cancel", {
                bubbles: true,
                composed: true,
                detail: {},
            })
        );
        this.hide();
    }

    override render() {
        return html`<sl-dialog id="dialog" label="Enter text geo coordinate">
            <ds-text-to-decimal-degrees
                @ds-changed=${(e: CustomEvent) => (this._location = e.detail.location)}
                @ds-error=${() => (this._location = undefined)}
            ></ds-text-to-decimal-degrees>
            ${litIf(
                !this._location,
                () => html`<p style="color:var(--sl-color-danger-400)">Invalid coordinate text</p>`,
                () => html`<p>Lat: ${this._location?.lat} Lon: ${this._location?.lon}</p>`
            )}
            <div slot="footer">
                <sl-button variant="primary" @click=${() => this.cancel()}> Cancel</sl-button>
                <sl-button
                    variant="primary"
                    ?disabled=${!this._location}
                    @click=${() => {
                        this.dispatchEvent(
                            makeCustomEvent("on-approved", { location: this._location })
                        );
                        this.hide();
                    }}
                >
                    Accept</sl-button
                >
            </div>
        </sl-dialog>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-text-to-decimal-degrees": TextToDecimalDegrees;
        "ds-text-to-decimal-degrees-dialog": TextToDecimalDegreesDialog;
    }
}
